/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_CreatingInputs */

const en_options_api_keys_creating = /** @type {(inputs: Options_Api_Keys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating new API Key. Please wait...`)
};

const fr_options_api_keys_creating = /** @type {(inputs: Options_Api_Keys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création de la clé API. Veuillez patienter...`)
};

const de_options_api_keys_creating = /** @type {(inputs: Options_Api_Keys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer API-Schlüssel wird erstellt. Bitte warten...`)
};

const it_options_api_keys_creating = /** @type {(inputs: Options_Api_Keys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione di una nuova chiave API. Attendi...`)
};

const ru_options_api_keys_creating = /** @type {(inputs: Options_Api_Keys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание нового ключа API. Пожалуйста, подождите...`)
};

const es_options_api_keys_creating = /** @type {(inputs: Options_Api_Keys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando nueva clave API. Espere...`)
};

const zh_cn2_options_api_keys_creating = /** @type {(inputs: Options_Api_Keys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在创建新的 API 密钥。请稍候……`)
};

const ja_options_api_keys_creating = /** @type {(inputs: Options_Api_Keys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいAPIキーを作成しています。お待ちください...`)
};

const hi_options_api_keys_creating = /** @type {(inputs: Options_Api_Keys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई API कुंजी बनाई जा रही है। कृपया प्रतीक्षा करें...`)
};

const pt_pt2_options_api_keys_creating = /** @type {(inputs: Options_Api_Keys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando nova chave de API. Aguarde...`)
};

/**
* | output |
* | --- |
* | "Creating new API Key. Please wait..." |
*
* @param {Options_Api_Keys_CreatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_creating = /** @type {((inputs?: Options_Api_Keys_CreatingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_CreatingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_creating(inputs)
	if (locale === "de") return de_options_api_keys_creating(inputs)
	if (locale === "it") return it_options_api_keys_creating(inputs)
	if (locale === "ru") return ru_options_api_keys_creating(inputs)
	if (locale === "es") return es_options_api_keys_creating(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_creating(inputs)
	if (locale === "ja") return ja_options_api_keys_creating(inputs)
	if (locale === "hi") return hi_options_api_keys_creating(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_creating(inputs)
	return en_options_api_keys_creating(inputs)
});